import BlockMedia from 'components/BlockMedia';
import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import type { DigizuiteAsset } from 'models/asset';
import type { ColorField, Field, SitecoreBlockProps } from 'models/sitecore';
import type { JSONObject } from 'types';
import { getEditorMargin } from 'utils/business-logic';
import { getAsset } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		backgroundColor?: ColorField;
		body?: JSONObject;
		campaignBubbleLabel?: Field<string>;
		campaignBubbleSale?: Field<boolean>;
		campaignBubbleText?: Field<string>;
		datasourceName?: string;
		isWide?: Field<boolean>;
		landscapeImage?: Field<DigizuiteAsset[]>;
		preventAutoplay?: Field<boolean>;
		video?: Field<DigizuiteAsset[]>;
	};
}

export default function MediaSingle({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const { datasourceName, isWide, preventAutoplay } = fields;
	const landscapeImg = getAsset('Templated 2:1', fields.landscapeImage);
	const video = getAsset('Source Copy', fields.video);

	if (!landscapeImg && !video) {
		return (
			<ComponentPlaceholder
				componentName="MediaSingle"
				className={getEditorMargin(params)}
			/>
		);
	}

	return (
		<LayoutContainer
			backgroundColor={fields.backgroundColor?.fields?.colorHex?.value}
			outerClassName={getEditorMargin(params)}
			id={params?.anchor}
		>
			<BlockMedia
				image={{
					src: landscapeImg?.src,
					alt: landscapeImg?.alt,
					variant: 'landscape2x1Large',
				}}
				video={video}
				className={isWide?.value ? undefined : 'max-w-col-6'}
				campaignBubbleSmallSize="small"
				campaignBubbleLargeSize="large"
				campaignBubbleLabel={fields.campaignBubbleLabel?.value}
				campaignBubbleSale={fields.campaignBubbleSale?.value}
				campaignBubbleText={fields.campaignBubbleText?.value}
				productsDisplayType="shopByMedia"
				productsRequestBody={fields.body}
				preventAutoplay={preventAutoplay?.value}
				gtmItemListId="block"
				gtmItemListName={`Block: ${datasourceName ?? 'MediaSingleUnknown'}`}
			/>
		</LayoutContainer>
	);
}
MediaSingle.displayName = 'MediaSingle';
